/* eslint-disable no-empty-pattern */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getAllPrivileges = createAsyncThunk(
  "permission/getAllPrivileges",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getAllPrivileges");
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const PermissionSlice = createSlice({
  name: "permission",
  initialState: {
    permissionsList: [],
    loading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getAllPrivileges.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllPrivileges.fulfilled, (state, action) => {
      state.loading = false;
      state.permissionsList = action.payload;
      state.error = null;
    });
    builder.addCase(getAllPrivileges.rejected, (state, action) => {
      state.loading = false;
      state.permissionsList = [];
      state.error = action.payload;
    });
  },

  reducers: {},
});

export const {} = PermissionSlice.actions;

export default PermissionSlice.reducer;
